import Privacy from '@module/privacy';
import LaunchDarkly from '@module/launchdarkly';

import { EXPERIMENT_COOKIE_BANNER } from '@app/constant/experiments';

export const init = () => {
  if (
    LaunchDarkly.getVariant(EXPERIMENT_COOKIE_BANNER) ||
    (Privacy.userHasClosedBanner() && !Privacy.userAllowsTracking())
  ) {
    // Only init this if the experiment is running or
    // if the user has taken part of that experiment
    Privacy.configure();
  }
};
